import { useState } from 'react';

export function useSelect(initialValue) {
  const [selectedValue, setSelectedValue] = useState(initialValue);

  return [selectedValue, setSelectedValue];
}
